<template>
  <div
    style="
      background-color: var(--color-white);
      padding: 20px;
      margin-bottom: 40px;
      border-radius: 4px;
    "
  >
    <div class="row">
      <!-- Left side - City and Corporation -->
      <div class="col-5">
        <div class="row">
          <div class="col-4 mb-2">
            <div class="signature-line-city" style="font-size: 14px; line-height: 1.2; padding-bottom: 30px; position: relative;">
              {{
                $t(
                  `project.previewAndReport.reportTypes.${reportType}.signature.city`
                )
              }}
              <div style="position: absolute; bottom: 0px; left: 0; font-size: 14px; z-index: 1;">{{ currentDate }}</div>
            </div>
          </div>
          <div class="col-8 mb-2">
            <div class="signature-line-corporation" style="font-size: 14px; white-space: nowrap; width: 100%;">
              {{
                $t(
                  `project.previewAndReport.reportTypes.${reportType}.signature.corporation`
                )
              }}
            </div>
          </div>
        </div>
      </div>
      
      <!-- Spacer -->
      <div class="col-2"></div>
      
      <!-- Right side - Date and Signature -->
      <div class="col-5">
        <div class="row">
          <div class="col-6 mb-2">
            <div class="signature-line" style="font-size: 14px;">
              {{
                $t(
                  `project.previewAndReport.reportTypes.${reportType}.signature.date`
                )
              }}
            </div>
          </div>
          <div class="col-6 mb-2">
            <div class="signature-line" style="font-size: 14px;">
              {{
                $t(
                  `project.previewAndReport.reportTypes.${reportType}.signature.signature`
                )
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "DateSignatureSection",
  props: {
    reportType: {
      type: String,
      required: true,
    },
  },
  setup() {
    const currentDate = computed(() => {
      const now = new Date();
      const day = String(now.getDate()).padStart(2, '0');
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const year = now.getFullYear();
      return `${day}/${month}/${year}`;
    });

    return {
      currentDate,
    };
  },
});
</script>

<style scoped>
.signature-line {
  position: relative;
  padding-bottom: 30px;
}

.signature-line::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 120px;
  height: 1px;
  background-color: var(--color-dark);
}

.signature-line-corporation::after {
  width: 120px;
  height: 1px;
  bottom: -5px;
}

.signature-line-city::after {
  width: 80px;
  height: 1px;
  bottom: -10px;
}
</style>
